<template>
    <div id='login-page-container' class='container-fluid page'>
        <card title='Connexion' iconClass='icon-lock'>
            <form novalidate action='#' @submit.prevent='connect'>
                <div class='form-group row' style='min-height:60px;'>
                    <div class='col-sm-12'>
                        <label for='email'></label>
                        <input type='email' class='form-control' id='email' name='email'
                               placeholder='Entrez votre Email'
                               onfocus="this.placeholder=''"
                               onblur="this.placeholder='Entrez votre Email'" v-model='email'
                               :class="[{'form-control':true, 'is-invalid' : !validEmail(email) && blur_email},{'form-control':true, 'is-valid' : validEmail(email) && blur_email}]"
                               v-on:blur='blur_email = true'/>
                        <div class='invalid-feedback'>
                            {{ error_email }}
                        </div>
                        <div class='valid-feedback'>
                            Email valide.
                        </div>
                    </div>
                </div>

                <div class='form-group row' style='min-height:60px;'>
                    <div class='col-sm-12 input-group'>
                        <label for='password'></label>
                        <input :type='passwordFieldType' v-model='password' class='form-control'
                               id='password' name='password'
                               placeholder='Entrez votre mot de passe'
                               onfocus="this.placeholder=''"
                               onblur="this.placeholder='Entrez votre mot de passe'"
                               :class="[{'form-control':true, 'is-invalid' : !validPassword(password) && blur_password},{'form-control':true, 'is-valid' : validPassword(password) && blur_password}]"
                               v-on:blur='blur_password = true'/>
                        <div class='input-group-append' @mousedown='showPasswords'
                             @mouseup='hidePasswords' style='max-height: 38px;'>
                            <span class='input-group-text'><span class='icon-eye'></span></span>
                        </div>
                        <div class='invalid-feedback'>
                            {{ error_password }}
                        </div>
                        <div class='valid-feedback'>
                            Mot de passe valide.
                        </div>
                    </div>
                </div>
                <div class='form-group row'>
                    <div class='col-sm-12 input-group'>
                        <button class='btn btn-lg btn-primary btn-block text-uppercase' type='submit'>
                            <span class='icon-signin'></span> Se connecter
                        </button>
                    </div>
                </div>
            </form>
            <div class='row' style='text-align: center;'>
                <div class='col-6'>
                    <router-link :to="{ name: 'register' }">Créer votre compte</router-link>
                </div>
                <div class='col-6'>
                    <router-link :to="{ name: 'forgotten-password' }">Mot de passe oublié ?</router-link>
                </div>
            </div>
            <div id='loader-container'>
                <PulseLoader :loading='loading' :color='color' :size='size'></PulseLoader>
            </div>
        </card>
    </div>
</template>

<script>
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
    import Card from '../components/auth/Card';

    export default {
        name: 'connexion',
        components: {
            PulseLoader,
            Card
        },
        computed: {
            valid: function () {
                return this.valid_password && this.valid_email;
            }
        },
        data() {
            return {
                passwords_not_matching: '',
                auth_not_active: '',
                user_not_registrered: '',

                //Component intern props
                email: '',
                valid_email: false,
                error_email: '',
                blur_email: false,

                password: '',
                valid_password: false,
                error_password: '',
                blur_password: false,

                passwordFieldType: 'password',
                //PulseLoader props
                loading: false,
                color: '#d93752',
                size: '1em'
            }
        },
        methods: {
            showPasswords: function () {
                this.passwordFieldType = 'text'
            },
            hidePasswords: function () {
                this.passwordFieldType = 'password'
            },
            validate: function () {
                this.blur_email = true;
                this.blur_password = true;
                if (this.validEmail(this.email)) {
                    this.valid_email = true;
                } else {
                    this.valid_email = false;
                }
                if (this.validPassword(this.password)) {
                    this.valid_password = true;
                } else {
                    this.valid_password = false;
                }
            },
            validEmail: function (email) {
                if (this.email.trim().length == 0) {
                    this.error_email = 'Merci de renseigner un Email.'
                    return false;
                }

                var re = /(.+)@(.+){2,}\.(.+){2,}/;

                if (!re.test(email.toLowerCase())) {
                    this.error_email = 'Merci de renseigner un email valide.';
                    return false;
                }

                if (this.auth_not_active == email) {
                    this.error_email = 'Ce compte n\'est pas actif.';
                    return false;
                }

                if (this.user_not_registrered == email) {
                    this.error_email = 'Aucun compte ne correspond à cet Email.';
                    return false;
                }

                return true;
            },
            validPassword: function (password) {
                if (this.password.trim().length == 0) {
                    this.error_password = 'Merci de renseigner un mot de passe.'
                    return false;
                }
                if (this.passwords_not_matching == password) {
                    this.error_password = 'Mot de passe incorrect.';
                    return false;
                }
                return true;
            },
            keymonitor: function (event) {
                if (event.key == 'Enter') {
                    this.connect()
                }
            },
            connect: function () {
                this.validate();
                if (this.valid) {
                    this.loading = true;
                    this.$store.dispatch('postApi', {
                        'controller': 'PCAuth',
                        'action': 'connect',
                        'post': {
                            email: this.email,
                            password: this.password,
                        }
                    })
                        .then(response => {
                            this.loading = false
                            if (response.data.error === 'auth_not_active') {
                                this.auth_not_active = this.email;
                            } else if (response.data.error === 'user_not_registrered') {
                                this.user_not_registrered = this.email;
                            } else if (response.data.error === 'passwords_not_matching') {
                                this.passwords_not_matching = this.password;
                            } else {
                                window.location.href = 'index.php';
                            }
                        })
                }
            },
        }
    }
</script>
<style lang='scss'>
    :root {
        --input-padding-x: 1.5rem;
        --input-padding-y: .75rem;
    }

    .form-signin {
        width: 100%;
    }

    .form-signin .btn {
        font-size: 80%;
        border-radius: 5rem;
        letter-spacing: .1rem;
        font-weight: bold;
        padding: 1rem;
        transition: all 0.2s;
    }

    .form-label-group {
        position: relative;
        margin-bottom: 1rem;
    }

    .form-label-group input {
        border-radius: 2rem;
    }

    .form-label-group > input,
    .form-label-group > label {
        padding: var(--input-padding-y) var(--input-padding-x);
    }

    .form-label-group > label {
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
        margin-bottom: 0;
        /* Override default `<label>` margin */
        line-height: 1.5;
        color: #495057;
        border: 1px solid transparent;
        border-radius: .25rem;
        transition: all .1s ease-in-out;
    }

    #loader-container {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/views/Login.vue